import { createContext } from 'react';

const context = {
  goBack: () => {},
  goNext: () => {},
  direction: 'next',
  onSubmit: () => {},
  setOnSubmit: () => {},
  lastNavigatedAt: Date.now(),
  nextButtonDisabled: false,
  setNextButtonDisabled: () => {},
  nextButtonVisible: false,
};

export const NavigationContext = createContext(context);
